import clsx from 'clsx';

import cn from '@/lib/clsxm';

import Props from '@/components/@base/alert/type';
import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';

import imagesList from '@/constant/images-list';

const alertStyles = {
  error: {
    className: 'bg-[#FF4C2414] text-[#FF6437]',
    buttonClassName: 'bg-[#48A1FB] hover:bg-[#F0F8FF] hover:text-[#6097F3]',
    icon: imagesList.icons.errorIcon,
  },
  success: {
    className: 'bg-[#88C8291A] text-[#7BB81F]',
    buttonClassName: 'bg-[#48A1FB] hover:bg-[#F0F8FF] hover:text-[#6097F3]',
    icon: imagesList.icons.successIcon,
  },
  warning: {
    className: 'bg-[#FFC1071A] text-[#D6A205]',
    buttonClassName: 'bg-[#48A1FB] hover:bg-[#F0F8FF] hover:text-[#6097F3]',
    icon: imagesList.icons.warningIcon,
  },
  info: {
    className: 'bg-[#F2F8FF] text-[#1A73E8]',
    buttonClassName: 'bg-[#48A1FB] hover:bg-[#F0F8FF] hover:text-[#6097F3]',
    icon: imagesList.icons.infoAlertIcon,
  },
  default: {
    className: 'bg-[#F2F8FF] text-[#1A73E8]',
    buttonClassName: 'bg-[#48A1FB] hover:bg-[#F0F8FF] hover:text-[#6097F3]',
    icon: imagesList.icons.infoAlertIcon,
  },
};

export default function Alert({
  message,
  buttonText,
  type = 'default',
  className,
  buttonOnClick,
  buttonTextClassName,
  messageClassName,
}: Props) {
  return (
    <Container
      center
      className={cn(
        'w-full justify-between rounded-xl p-5 leading-8',
        alertStyles[type].className,
        className,
      )}
    >
      <Container center className='gap-1.5 sm:gap-3.5'>
        <XImage src={alertStyles[type].icon} alt={type} width={20} height={20} />
        <Text bold className={clsx(messageClassName, 'text-[15px]')}>
          {message}
        </Text>
      </Container>
      {buttonText && (
        <Button
          onClick={buttonOnClick}
          className={cn(
            alertStyles[type].buttonClassName,
            buttonTextClassName,
            'h-10 text-[15px] text-white',
          )}
        >
          {buttonText}
        </Button>
      )}
    </Container>
  );
}
